import { Mail, MessageCircle, Calendar, Users, MapPin, Car, BadgeCheck } from "lucide-react";

export const STATUSES = [
  { id: "nueva", label: "Nueva", cls: "bg-barro text-white" },
  { id: "contactada", label: "Contactada", cls: "bg-sol text-mar" },
  { id: "cerrada", label: "Cerrada", cls: "bg-brasil text-white" },
];

const fmtDate = (iso) => {
  const d = new Date(iso);
  return isNaN(d) ? "" : d.toLocaleString("es-PY", { dateStyle: "medium", timeStyle: "short" });
};

const waHref = (lead) => {
  const digits = (lead?.telefono || "").replace(/\D/g, "");
  if (digits.length < 8) return null;
  const msg = `¡Hola ${lead.nombre}! Te escribimos de Jaha Brasilpe por tu solicitud de viaje${lead.destino ? ` a ${lead.destino}` : ""}.`;
  return `https://wa.me/${digits}?text=${encodeURIComponent(msg)}`;
};

const Info = ({ icon: Icon, children }) => (
  <span className="flex items-center gap-1.5 text-sm text-tinta/75"><Icon className="h-4 w-4 text-mar" />{children}</span>
);

export const LeadCard = ({ lead, onStatus, busy }) => {
  const wa = waHref(lead);
  return (
    <article data-testid={`lead-card-${lead.id}`} className="rounded-3xl border border-mar/10 bg-white p-6 shadow-[0_20px_40px_-30px_rgba(27,42,92,0.5)]">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <h3 className="font-display text-xl font-bold text-mar">{lead.nombre}</h3>
          <p className="text-xs text-tinta/60">{fmtDate(lead.created_at)}</p>
        </div>
        <div className="flex gap-1 rounded-full bg-arena p-1" role="group" aria-label="Estado">
          {STATUSES.map((s) => (
            <button key={s.id} data-testid={`lead-status-${s.id}-${lead.id}`} disabled={busy} onClick={() => onStatus(lead.id, s.id)}
              className={`rounded-full px-3 py-1.5 text-xs font-bold transition-colors ${lead.status === s.id ? s.cls : "text-tinta/60 hover:text-mar"}`}>
              {s.label}
            </button>
          ))}
        </div>
      </div>
      <div className="mt-4 flex flex-wrap gap-x-5 gap-y-2">
        {lead.transporte && <Info icon={Car}>{lead.transporte}</Info>}
        {lead.plan && <Info icon={BadgeCheck}>Plan: {lead.plan}</Info>}
        {lead.destino && <Info icon={MapPin}>{lead.destino}</Info>}
        {lead.fechas && <Info icon={Calendar}>{lead.fechas}</Info>}
        {lead.viajeros && <Info icon={Users}>{lead.viajeros}</Info>}
      </div>
      {lead.mensaje && <p className="mt-4 rounded-2xl bg-arena/70 p-4 text-sm leading-relaxed text-tinta/85">{lead.mensaje}</p>}
      <div className="mt-5 flex flex-wrap items-center gap-2">
        {wa ? (
          <a data-testid={`lead-whatsapp-${lead.id}`} href={wa} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 rounded-full bg-[#25D366] px-4 py-2 text-sm font-bold text-mar">
            <MessageCircle className="h-4 w-4" /> WhatsApp {lead.telefono}
          </a>
        ) : (
          <span className="rounded-full bg-arena px-4 py-2 text-xs font-semibold text-tinta/60">Sin teléfono</span>
        )}
        <a data-testid={`lead-email-${lead.id}`} href={`mailto:${lead.email}`} className="flex items-center gap-2 rounded-full border border-mar/20 px-4 py-2 text-sm font-semibold text-mar hover:bg-arena">
          <Mail className="h-4 w-4" /> {lead.email}
        </a>
      </div>
    </article>
  );
};
